import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-406235ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside-main_sticky" }
const _hoisted_2 = { class: "aside-main_actions flex" }
const _hoisted_3 = { class: "bottom-actions" }
const _hoisted_4 = { class: "aside-main_actions_company-wrapper flex" }

import {ref, watch} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useAsideMenu} from '../aside-menu.store';
    import CompanySelector from './CompanySelector.vue';
    import LanguageSelector from './LanguageSelector.vue';
    import NavigationTabsContainer from './NavigationTabsContainer.vue';
    import {useDisplayMobile} from '@/logged/common/composables';
    import {LogoWrapper, Skeleton} from '@/logged/common/ui';
    import {useAppContext} from '@/logged/config';
    import {useUser} from '@/logged/features/user';
    import {useDisplayMode} from '../stores';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AsideMenu',
  setup(__props) {

    const asideMenuStore = useAsideMenu();
    const appContext = useAppContext();
    const userStore = useUser();
    const displayModeStore = useDisplayMode();

    const {isMobileNavBarOpened} = storeToRefs(asideMenuStore);
    const {isDisplayModeFull, isDisplayModeReduced} = storeToRefs(displayModeStore);
    const {loading} = storeToRefs(appContext);

    const {isDisplayMobile} = useDisplayMobile();

    const asideRef = ref<HTMLDivElement>();

    function handleCloseMobileNavBar() {
        asideMenuStore.setMobileNavBarOpened(false);
    }

    watch(isDisplayMobile, (value) => {
        if (value) {
            setTimeout(() => {
                if (asideRef.value) {
                    asideRef.value.style.transitionProperty = 'transform';
                }
            }, 300);
        } else {
            setTimeout(() => {
                if (asideRef.value) {
                    asideRef.value.style.transitionProperty = 'width, transform';
                }
            }, 300);
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["aside-root", {isMobile: _unref(isDisplayMobile)}])
  }, [
    _createElementVNode("aside", {
      ref_key: "asideRef",
      ref: asideRef,
      class: _normalizeClass(["aside-main flex", {isFull: _unref(isDisplayModeFull), isReduced: _unref(isDisplayModeReduced), isMobile: _unref(isDisplayMobile)}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(LogoWrapper))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(NavigationTabsContainer),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_unref(loading) && !_unref(userStore).selectedIdentity)
              ? (_openBlock(), _createBlock(_unref(Skeleton), { key: 0 }))
              : (_openBlock(), _createBlock(CompanySelector, { key: 1 }))
          ]),
          _createVNode(LanguageSelector)
        ])
      ])
    ], 2),
    _createVNode(_Transition, { name: "fade-opacity" }, {
      default: _withCtx(() => [
        (_unref(isDisplayMobile) && _unref(isMobileNavBarOpened))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "aside-overlay",
              onClick: handleCloseMobileNavBar
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})